import script from "./newsletter_optin.vue?vue&type=script&setup=true&lang=js"
export * from "./newsletter_optin.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__